var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-radio-button" },
    _vm._l(_vm.options, function(option, index) {
      return _c(
        "div",
        {
          key: option,
          staticClass: "c-radio-button__option",
          attrs: { role: "radiogroup" }
        },
        [
          _c(
            "Btn",
            {
              attrs: {
                type: _vm.active == index ? "primary" : "primary-open",
                "button-size": ["small", "thin"],
                "aria-label":
                  _vm.activeIndex == index
                    ? option + " currently selected."
                    : ""
              },
              on: { click: _vm.buttonClick }
            },
            [_vm._v("\n      " + _vm._s(option) + "\n    ")]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }